<!-- full width slider -->
<slider
	[masterImage]="tourService.record.master_image"
	[carousel_images]='tourService.record.language_contents.carousel_images || []'
></slider>

<div class="container pt-30">
	<!-- categories -->
	<span *ngFor='let category of tourService.categories' class="category" [class.without_slider]='tourService.record.language_contents?.carousel_images.length == 0'>
		<a [routerLink]="['/d', appService.domainId, 'category', category['id']]">{{category["description"]}}</a>
	</span>

	<!-- mobile section -->
	<div class="row mobile-price">
		<section class="activity__price activity__price--mobile">
			<div class="price-block price-block--has-price">
				<div class="price-block-display-price-wrapper">
					<p class="price-block-display-price">
						<span class="price-block__from">Da</span>
						<strong class="price-block__price-actual">{{tourService.defaultPrice | currency:'EUR'}}</strong>
						<span class="price-block__explanation">{{'a persona' | translate}}</span>
					</p>
				</div>
			</div>
		</section>
	</div>

	<!-- desktop -->
	<div class="row activity-row">
		<div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-12">
			<div class="row">
				<div class="col-12">
					<h1 [innerHtml]='tourService.record?.language_contents?.description' class="activity-title"></h1>
				</div>
			</div>

			<!-- short description -->
			<div class="row activity-row" *ngIf='tourService.properties && tourService.properties["tour_brief"].value'>
				<div class="col-12">
					<div class="overview">
						<section class="activity-overview">
							<p [innerHtml]='tourService.properties["tour_brief"].value'></p>
						</section>
					</div>
				</div>
			</div>

			<!-- facilities -->
			<div class="toggle-mobile useful-information row" [class.without_booking_form]='!tourService.actual_trips_first_available_date' *ngIf='tourService.record.language_contents?.facilities.length'>
				<div class="col-12 border-top key-details">
					<section id="key-details" class="activity-key-details js-section-content">
						<h3 class="activity-key-details__title" (click)="toggleContent('info_utili')" [ngClass]='isToggleActive["info_utili"] ? "open-toggle": ""'>
							{{'Informazioni Utili' | translate}}
						</h3>
						<!-- contenuto -->
						<div id="single_tour_facilities" class="toggle-content" [ngClass]='isToggleActive["info_utili"] ? "active": ""'>
							<ul>
								<ng-container *ngFor='let facility of tourService.record.language_contents.facilities'>
									<li class="facility">
										<i [class]='facility.slug'></i>
										<span class="name">{{facility.title}}</span>
										<span class="description">{{facility.description}}</span>
									</li>
								</ng-container>
							</ul>
						</div>
					</section>
				</div>
			</div>

			<!-- booking form -->
			<div class="row" #bookingForm>
				<div class="col-12 no-padding-right-col">
					<booking-form></booking-form>
				</div>
			</div>

			<!-- descrizione -->
			<div class="row content_tour toggle-mobile" [class.without_booking_form]='!tourService.actual_trips_first_available_date' *ngIf='tourService.properties && tourService.properties["full_description"].value'>
				<div class="col-12 border-top">
					<h3 (click)="toggleContent('descrizione')" [ngClass]='isToggleActive["descrizione"] ? "open-toggle": ""'>{{'Descrizione' | translate}}</h3>
					<div class="toggle-content" [ngClass]="isToggleActive['descrizione'] ? 'active' : ''" [innerHtml]='tourService.properties["full_description"].value'></div>
				</div>
			</div>

			<div class="features-tour-list toggle-mobile" [ngClass]='tourService.properties && !tourService.properties["full_description"].value ? "no-margin-top" : ""' *ngIf='(tourService.properties && tourService.properties.included_services.value && tourService.properties.included_services.value.length) || (tourService.properties && tourService.properties.excluded_services.value && tourService.properties.excluded_services.value.length)'>
				<div class="row">
					<div class="col-12 border-top">
						<h3 (click)="toggleContent('incl_escl')" [ngClass]='isToggleActive["incl_escl"] ? "open-toggle": ""'>{{'Cosa è incluso/escluso' | translate}}</h3>
						<div class="toggle-content" [ngClass]="isToggleActive['incl_escl'] ? 'active' : ''">
							<ul id="features-list">
								<ng-container *ngIf='tourService.properties && tourService.properties.included_services.value'>
									<ng-container *ngFor='let includedService of tourService.properties.included_services.value'>
										<li class="featured-included" [innerHtml]='includedService'></li>
									</ng-container>
								</ng-container>
								<ng-container *ngIf='tourService.properties && tourService.properties.excluded_services.value'>
									<ng-container *ngFor='let excludedService of tourService.properties.excluded_services.value'>
										<li class="featured-not-included" [innerHtml]='excludedService'></li>
									</ng-container>
								</ng-container>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="row toggle-mobile note" [ngClass]='(!tourService.properties && !tourService.properties.included_services.value) || (tourService.properties && !tourService.properties.excluded_services.value) ? "no-margin-top" : ""' *ngIf='tourService.properties && tourService.properties["schedule_info"].value'>
				<div class="col-12 border-top">
					<h3 (click)="toggleContent('note')" [ngClass]='isToggleActive["note"] ? "open-toggle": ""'>{{'Note' | translate}}</h3>
					<div class="toggle-content" [ngClass]="isToggleActive['note'] ? 'active' : ''" [innerHtml]='tourService.properties["schedule_info"].value'></div>
				</div>
			</div>

			<div class="row toggle-mobile destinations" [ngClass]='tourService.properties && !tourService.properties["schedule_info"].value ? "no-margin-top" : ""' *ngIf='tourService.record.destinations.length'>
				<div class="col-12 border-top">
					<h3 (click)="toggleContent('destinazioni')" [ngClass]='isToggleActive["destinazioni"] ? "open-toggle": ""'>{{'Destinazioni' | translate}}</h3>
					<ul class="toggle-content trip_destinations" [ngClass]="isToggleActive['destinazioni'] ? 'active' : ''">
						<li class="border-top" *ngFor='let destination of tourService.record.destinations'>
							<img src='./assets/img/pin-marker.png' class='pin-marker'/>
							{{destination.description}}
							<ng-container *ngIf='destination.properties.geo_position.value'>
								<a [href]='geoPosition(destination)' target="_blank">{{'Apri su Google Map' | translate}}</a>
							</ng-container>
						</li>
					</ul>
				</div>
			</div>

			<div class="row before-leaving-wrapper toggle-mobile" [ngClass]='!tourService.record.destinations.length ? "no-margin-top" : ""' *ngIf='tourService.properties && tourService.properties["before_leaving"].value'>
				<div class="col-12 border-top">
					<h3 (click)="toggleContent('prima_di_partire')" [ngClass]='isToggleActive["prima_di_partire"] ? "open-toggle": ""'>{{'Prima di partire' | translate}}</h3>
					<div class="toggle-content" [ngClass]="isToggleActive['prima_di_partire'] ? 'active' : ''">
						<ul id="before_leaving">
							<ng-container *ngFor='let beforeLeavingRule of tourService.properties["before_leaving"].value'>
								<li [innerHtml]='beforeLeavingRule'></li>
							</ng-container>
						</ul>
					</div>
				</div>
			</div>

			<div class="empty_space"></div>
		</div>
		<div class="col-md-4 col-sm-12 price-block-outside no-padding-right-col" *ngIf='tourService.actual_trips_first_available_date && tourService.defaultPrice'>
			<section>
				<div class="price-block price-block--has-price">
					<div class="price-block-display-price-wrapper">
						<p class="price-block-display-price">
							<span class="price-block__from">{{'A partire da' | translate}}</span>
							<span class="price-block__price-actual">{{tourService.defaultPrice | currency:'EUR'}}</span>
							<span class="price-block__explanation">{{'a persona' | translate}}</span>
						</p>

						<div class="price-block__button">
							<button type="button" class="gtm-trigger__book-now-price-box-btn btn btn-cta" (click)='scrollToBooking(bookingForm)'>
								{{'Prenota ora' | translate}}
							</button>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</div>
